// $.getJSON('/cart.js', function(cart) {
//   var cartCount = cart.item_count;
//   var cartText = "(" + cartCount + " " + (cartCount == 1 ? "item" : "items") + ")";
//   $('.drcart_count').text(cartText);
// });
// comment 
$(document).ready(function(){
  $(".shop-for-product").click(function() {
      $("html, body").animate({
        scrollTop: $(".sidebar-product-option").offset().top
      }, 1000); // Change the duration (in milliseconds) as per your preference
    });
  
  $("div.landing-page-wraps .btn:not('.add-to-cart')").click(function(e) {
      e.preventDefault();
      $("html, body").animate({
        scrollTop: $("div.landing-page-wraps .page-content--product").offset().top
      }, 1000);
    });
    
  $('.vid_img_box').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows:true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows:false,
          }
        }
      ]
    });  
  
  $('.AddonItem__Row__Outerslider_addon').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true
    });
  
    $(window).on('resize', function(){
      $('.AddonItem__Row__Outerslider_addon').slick("unslick");
      setTimeout(function(){
        $('.AddonItem__Row__Outerslider_addon').not('.slick-initialized').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:true
        });
      },100)
    });
  
    var review_main = $(".review_main");
    review_main.slick({
      dots: false,
      autoplay:false,
      arrows: true,
      prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0558/0141/3767/files/prev-arrow.svg?v=1682504397" /></div>',
      nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0558/0141/3767/files/next-arrow.svg?v=1682504397" /></div>',
      slidesToShow: 3,
      slidesToScroll: 1,
       responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  
    // Product With Percentage 2 Slider
  
    //   $('.slider-video').slick({
    //     infinite: true,
    //     slidesToShow: 2,
    //     slidesToScroll: 1,
    //     arrows:true,
    //     dots:true,
    //     responsive: [ 
    //       {
    //         breakpoint: 991,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1    
    //         }
    //       },
    //       {
    //         breakpoint: 768,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1    
    //         }
    //       }     
    //     ]
    //   });  
    // var vids = $(".video-container video"); 
    // $.each(vids, function(){
    //        this.controls = false; 
    // }); 
  
    // $(".video-container").each(function() {
    // // Video
    //   var $video_container = $(this);
    //   var $video = $(this).find("video");
    
    //   // Video Controls
    //   var $video_controls = $(this).find(".video-inner-container");
    //    var $play_button = $(this).find(".play-gif");
    
    //   function playVideo(){
    //     if ($video[0].paused){
    //       $video[0].play();
    //       $video_controls.addClass("playing");
    //     } else {
    //       $video[0].pause();
    //       $video_controls.removeClass("playing"); 
    //     }
    //   }
    
    //   // Play/pause on button click
    //   $play_button.click(function() {
    //     playVideo();
    //   });
    
    // });
  
    jQuery('.user-thumb-marquee').marquee({
      direction: 'left',
      duration: 15000,
      gap: 24,
      delayBeforeStart: 0,
      duplicated: true,
      startVisible: true
    });
  }) 
  
  
  function add_to_cart_grid(variantid,qty){
      var id = variantid;
      var q = qty;
      var ajax = {
          type: "POST",
          url: "/cart/add.js",
          data: "quantity=" + q + "&id=" + id,
          dataType: "json",
          success: function (n) {
            var cart = new theme.CartDrawer
            cart.init();
            $.getJSON('/cart.js', function(cart) {
              var cartCount = cart.item_count;
              var cartText = "(" + cartCount + " " + (cartCount == 1 ? "item" : "items") + ")";
              $('.drcart_count').text(cartText);
            });
            cart.open();
            
          },
          error: function (n, c) {
             console.log('fail');
          }
       };
      jQuery.ajax(ajax)
    }
  
  
  // Define an empty array to store the selected free products
  //var selectedFreeProducts = [];
  
  var selectedPaidProducts = []; // initialize array to store selected products
  
    $(".read_how_btn").click(function() {
      $(this).hide();
      var $optionSingle = $(this).closest(".option-single");
      var $quantitySelector = $optionSingle.find(".quantity-selector-bundle");
      $quantitySelector.show();
      var productid = $optionSingle.data("product-id");
      var quantity = 1;
      updateSelectedProducts(productid, quantity);
      $quantitySelector.find(".quantity").text(quantity);
  
      $quantitySelector.find(".plus-btn").click(function() {
        quantity++;
        $quantitySelector.find(".quantity").text(quantity);
        updateSelectedProducts(productid, quantity);
      });
  
      $quantitySelector.find(".minus-btn").click(function() {
        if (quantity > 1) {
          quantity--;
          $quantitySelector.find(".quantity").text(quantity);
          updateSelectedProducts(productid, quantity);
        }
        else {
          quantity--;
          updateSelectedProducts(productid, quantity);
          $quantitySelector.hide();
          $(this).closest(".option-btn").find(".read_how_btn").show();
          removeSelectedProduct(productid);
          
        }
      });
  
      function updateSelectedProducts(productid, quantity) {
            var index = selectedPaidProducts.findIndex(x => x.productid === productid);
            if (index === -1) {
              selectedPaidProducts.push({productid: productid, productquantity: quantity});
            } else {
              selectedPaidProducts[index].productquantity = quantity;
            }
            
            var totalProductQuantity = selectedPaidProducts.reduce(function(total, product) {
              return total + product.productquantity;
            }, 0);
          
            console.log(selectedPaidProducts);
             //console.log(totalProductQuantity);
          
            if (totalProductQuantity >= 2) {
              $(".paid-products .plus-btn").addClass("paid-limit-reached");
          
              // add class "paid-limit-reached" to those option-single elements whose data-product-id is not present in selectedPaidProducts
              $(".paid-products .option-single").each(function() {
                var productid = $(this).data("product-id");
                var index = selectedPaidProducts.findIndex(x => x.productid === productid);
                if (index === -1) {
                  $(this).addClass("paid-limit-reached");
                }
              });
            } else {
             $('.add-to-cart-button').removeClass("active");
              $(".sidebar-product-option .plus-btn").removeClass("paid-limit-reached");
          
              // remove class "paid-limit-reached" from all option-single elements
              $(".paid-products .option-single").removeClass("paid-limit-reached");
            }
          }
  
      function removeSelectedProduct(productid) {
        var index = selectedPaidProducts.findIndex(x => x.productid === productid);
        if (index !== -1) {
          selectedPaidProducts.splice(index, 1);
          $(this).removeClass("paid-limit-reached"); 
        }
       }
    });
  
  
  
  $('div[data-product-blocks]').attr('class', 'product-sub-text').addClass('product-sub-text');
  
  $('.product-select-dropdown input[type="radio"]').on('change', function() {
      var selectedProductId = $(this).closest('.option-single').data('product-id');
      var selectedProduct = $('.product-select-dropdown').find('[data-product-id="' + selectedProductId + '"]');
      
      var productImage = selectedProduct.find('.option-thumb img').attr('src');
      var productName = selectedProduct.find('.option-title-des h5').text();
      
      $('.default-load-product').data('product-id', selectedProductId);
      $('.default-load-product .option-thumb img').attr('src', productImage);
      $('.default-load-product .option-title-des h5').text(productName);
  
      // Add selected product to selectedPaidProducts array
      var index = selectedPaidProducts.findIndex(x => x.productid === selectedProductId);
        if (index === -1) {
          selectedPaidProducts.push({ productid: selectedProductId, productquantity: 1 });
          $('.add-to-cart-button').addClass("active");
        } else {
          
          if (selectedPaidProducts[index].productquantity > 0) {
            selectedPaidProducts[index].productquantity = 1;
            $('.add-to-cart-button').addClass("active");
          } else {
            $('.add-to-cart-button').removeClass("active");
          }
        }
  
      console.log(selectedPaidProducts);
    
    });
  
  function buy_two_get_one(products) {
    var cartCount = 0; // Initialize the cart count to 0
  
    function addToCart(index) {
      if (index >= products.length) {
        // All products have been added to the cart
        //updateCartCount(cartCount);
        return;
      }
  
      var product = products[index];
      var id = product.productid;
      var q = product.productquantity;
  
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + id,
        dataType: "json",
        success: function (n) {
          var cart = new theme.CartDrawer
            cart.init();
            // $.getJSON('/cart.js', function(cart){
            //   var cartCount = cart.item_count;
            //   var cartText = "(" + cartCount + " " + (cartCount == 1 ? "item" : "items") + ")";
            //   $('.drcart_count').text(cartText);
            // });
            cart.open();
          // Increment the cart count
          cartCount += q;
          addToCart(index + 1); // Proceed to the next product
        },
        error: function (n, c) {
          console.log('fail');
          addToCart(index + 1); // Proceed to the next product even in case of failure
        }
      };
  
      jQuery.ajax(ajax);
    }
  
    // Start adding products to the cart recursively
    addToCart(0);
  }
   
  $('.add-to-cart-button').click(function () {
    buy_two_get_one(selectedPaidProducts);
    selectedPaidProducts = []; // Clear the selectedPaidProducts array
  });
  
  $(document).ready(function(){
    // $('a.smooth-redirect').on('click',function (e) {
    //     e.preventDefault();
    //     var target = this.hash;
    //     var $target = $(target);
    //     $('html, body').stop().animate({
    //         'scrollTop': $target.offset().top
    //     }, 900, 'swing', function () {
    //         // window.location.hash = target;
    //     });
    // });
  
  // $(".product-page-tab-button, .bundle-product-redirect-btn").on("click",function(event){
  //   event.preventDefault();
  //     $('html,body').animate({scrollTop: $(".product-single__meta").offset().top},1000);
  // });
  
  //   $(".product-redirect").on("click",function(event){
  //   event.preventDefault();
  //     $('html,body').animate({scrollTop: $(".product-single__meta").offset().top},1000);
  // });
  
    
  $(document).on("click",".redirect-atc-btn, .add-to-cart_bundle ",function(){
    setTimeout(function(){
      var LeakInCart = false
      var FreeProduct = false
      $.getJSON('/cart.js', function(cart){
       
        cart.items.forEach(function(item) {
          if(item.handle == 'leak-protection-1'){
            LeakInCart = true
          }
          if(item.handle == 'free-roll-on-perfume'){
            FreeProduct = true;
          }
        });
  
       if($("body").hasClass("product--venom™-pheromone-spray-perfumes") || $("body").hasClass("page-page-landing") || $('.free_products').length >= 1){  
          if(!FreeProduct){
            console.log('!FreeProduct');
                var data_id = $(".free_products input:checked").val();
                console.log('data_id',data_id)
                var data = {
                  quantity: 1,
                  id: data_id
                };
                jQuery.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: data,
                  dataType: 'json',
                  success: function(data){
                    CartDrawerInit();
                    console.log("%cFree product added successfully !" , "color: green;")
                  }
              });
          }
        }
  
      setTimeout(function(){
          if(!LeakInCart){
          console.log('!LeakInCart');
           var ID = $('.on-off').val();
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                  quantity: 1,
                  id: ID
              },
              dataType: 'json',
              success: function(){
                 CartDrawerInit();
              },
           });
        }
      },1200)
      
      });  
    },1000)
    setTimeout(function(){
          $.getJSON('/cart.js', function(cart){
           $('.drcart_count').text(cart.item_count);
         })
    },2000)
  })
  
  
  $(document).on("change",".on-off",function(){
    var ID = $(this).val();
    if($(this).is(':checked')){
         $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
              quantity: 1,
              id: ID
          },
          dataType: 'json',
          success: function() {
            CartDrawerInit();
          },
       });
     }else{
            $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                quantity: 0,
                id: ID
            },
            dataType: 'json',
            success: function() {
              CartDrawerInit();
            },
         });
     }
  })
  
  });
  
    if(document.querySelector('.redirect-atc-btn')){
  $(window).scroll(function(){
    var scroll = $(window).scrollTop();
    var sticky_top = $('.redirect-atc-btn').offset().top;
    if(scroll >= sticky_top){  
      $('.sticky-buttons').fadeIn();
    }
    else{
      $('.sticky-buttons').fadeOut();
    }
  });
    }
  
  
  function RemoveLeakProtection(){
       var ID = $('.on-off').val();
         $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                quantity: 0,
                id: ID
            },
            dataType: 'json',
            success: function() {
               CartDrawerInit();
            },
         });
  }
  
  function CartDrawerInit(){
    setTimeout(function(){
      // console.log('self CartDrawerInit');
      var cart = new theme.CartDrawer
      cart.init();
       $.getJSON('/cart.js', function(cart){
         // console.log('cartCount22',cart.item_count)
         // console.log('carttNew',cart)
         var cartCount = cart.item_count;
        
        $('.drcart_count').text(cart.item_count);
      })
    },500)  
  }
  
  
  function changeItemInCart(itemKey, callback , quantitity) {
    if(quantitity){quantitity = quantitity - 1}
      fetch('/cart/change.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              id: itemKey,
              quantity: quantitity ?  quantitity : 0
          })
      })
      .then(response => response.json())
      .then(data => {
          console.log('Cart updated:', data);
          if (callback) callback();
      })
      .catch(error => {
          console.error('Error updating cart:', error);
      });
  }
  
  // ==================================================================Testing removal function =====================================
  
  
  var Location = window.location.href
  if(Location.includes('/cart')){
    
  document.addEventListener("click", function(event) {
      if (event.target.matches(".js-qty__adjust--minus-custom")) {
          var removeItemKey = event.target.getAttribute('data-remove-item');
          const cartDrawer = document.getElementById('CartPageForm');
          const ThisOriginalRemove = event.target.closest('.cart__item').querySelector('button.js-qty__adjust--minus');
          if (removeItemKey) {
              const matchingItems = cartDrawer.querySelectorAll(`[data-remove-item="${removeItemKey}"]`);
               let totalQty = 0;
              let FreeItem = 0;
              let OtherItem = 0;
              let limitedProducts = 0
              matchingItems.forEach(function(item) {
                  if(item.hasAttribute('free-cart-item')){
                   FreeItem = 1 + FreeItem
                 }else if(item.hasAttribute('limit-bundle')){
                   for (let i = 0; i < item.closest('.cart__item').querySelector('input.js-qty__num').value; i++) {
                   limitedProducts++
                   }
                 }else{
                   OtherItem++
                 }
                  const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
                  totalQty += itemQtyInput ? parseInt(itemQtyInput.value) : 0;
              });
  
              console.log('matchingItemsQty', totalQty);
  
              if (!event.target.hasAttribute('free-cart-item') && FreeItem > 0 && OtherItem === 1 && !event.target.hasAttribute('limit-bundle')) {
                  const itemKeys = [];
                  matchingItems.forEach(function(item) {
                      const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
                      const itemQtyWrapper = item.closest('.cart__item').querySelector('.js-qty__wrapper');
                      const itemKey = item.getAttribute('item-id');
                       if(itemQtyWrapper){
                         itemQtyWrapper.classList.add('is-loading')
                       }
                      if (itemQtyInput) {
                          itemKeys.push(itemKey);
                      }
                  });
  
                  if (itemKeys.length > 0) {
                    function removeNextItem(index) {
                        if (index < itemKeys.length) {
                            changeItemInCart(itemKeys[index], function() {
                                console.log('Item removed:', index + 1);
                                removeNextItem(index + 1); // Proceed to the next item after the current one is removed
                            });
                        } else {
                            // All items have been processed, reinitialize the cart drawer
                            window.location.reload();
                        }
                    }
                
                    // Start removing items from the first one
                    removeNextItem(0);
                }
              } else if (event.target.hasAttribute('limit-bundle') && limitedProducts > 0 && FreeItem > 0 ) {
                  const itemKeys = [];
                  const itemQuantities = [];
                  const itemQtyInputs = [];
                  let totalQuantity = 0;
              
                  matchingItems.forEach(function(item) {
                      const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
                      const itemQtyWrapper = item.closest('.cart__item').querySelector('.js-qty__wrapper');
                      const itemKey = item.getAttribute('item-id');
                      const itemQuantity = parseInt(itemQtyInput.value);
              
                      if (itemQtyWrapper) {
                          itemQtyWrapper.classList.add('is-loading');
                      }
              
                      if (itemQtyInput) {
                          itemKeys.push(itemKey);
                          itemQuantities.push(itemQuantity);
                          itemQtyInputs.push(itemQtyInput);
                          totalQuantity += itemQuantity;
                      }
                  });
              
                  function removeNextItems(index, count) {
                      if (index < itemKeys.length && count < 2) {
                          const itemKey = itemKeys[index];
                          const quantity = itemQuantities[index];
                          
                          changeItemInCart(itemKey, function() {
                              console.log('Item removed:', index + 1);
                              removeNextItems(index + 1, count + 1);
                          }, quantity); // Pass negative quantity to remove items
                      } else if (count === 2 || index >= itemKeys.length) {
                          window.location.reload();
                      }
                  }
              
                  if (itemKeys.length > 0) {
                      removeNextItems(0, 0);
                  }
              }
               else {
                  ThisOriginalRemove.click();
              }
          } else {
              ThisOriginalRemove.click();
          }
      }
      if (event.target.matches(".cart__remove-custom a")) {
          var removeItemKey = event.target.getAttribute('data-remove-item-remove');
          const cartDrawer = document.getElementById('CartPageForm');
          const ThisOriginalRemove = event.target.closest('.cart__item').querySelector('button.js-qty__adjust--minus');
  
          if (removeItemKey) {
              const matchingItems = cartDrawer.querySelectorAll(`[data-remove-item-remove="${removeItemKey}"]`);
               let totalQty = 0;
              let FreeItem = 0;
              let OtherItem = 0;
              let limitedProducts = 0
              matchingItems.forEach(function(item) {
                 if(item.hasAttribute('free-cart-item-remove')){
                   FreeItem = 1 + FreeItem
                 }else if(item.hasAttribute('limit-bundle-remove')){
                   for (let i = 0; i < item.closest('.cart__item').querySelector('input.js-qty__num').value; i++) {
                   limitedProducts++
                   }
                 }else{
                   OtherItem++
                 }
                  const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
                  totalQty += itemQtyInput ? parseInt(itemQtyInput.value) : 0;
              });
  
              console.log('matchingItemsQty', totalQty);
  
              if (!event.target.hasAttribute('free-cart-item-remove') && FreeItem > 0 && OtherItem === 1 && !event.target.hasAttribute('limit-bundle-remove')) {
                  const itemKeys = [];
                  matchingItems.forEach(function(item) {
                      const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
                      const itemQtyWrapper = item.closest('.cart__item').querySelector('.js-qty__wrapper');
                      const itemKey = item.getAttribute('item-id-remove');
                       if(itemQtyWrapper){
                         itemQtyWrapper.classList.add('is-loading')
                       }
                      if (itemQtyInput) {
                          itemKeys.push(itemKey);
                      }
                  });
                 console.log('itemKeys', itemKeys)
                  if (itemKeys.length > 0) {
                      let itemsProcessed = 0;
                  
                      itemKeys.forEach(function(itemKey, index) {
                          changeItemInCart(itemKey, function() {
                              itemsProcessed++;
                              if (itemsProcessed === itemKeys.length) {
                                  // All items have been processed, reinitialize the cart drawer
                                  window.location.reload();
                              }
                        console.log('itemsProcessed', itemsProcessed)
                          });
                      });
                  }
  
              } else if (event.target.hasAttribute('limit-bundle-remove') && limitedProducts > 0 && FreeItem > 0 ) {
                  const itemKeys = [];
                  const itemQuantities = [];
                  const itemQtyInputs = [];
                  let totalQuantity = 0;
              
                  matchingItems.forEach(function(item) {
                      const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
                      const itemQtyWrapper = item.closest('.cart__item').querySelector('.js-qty__wrapper');
                      const itemKey = item.getAttribute('item-id-remove');
                      const itemQuantity = parseInt(itemQtyInput.value);
              
                      if (itemQtyWrapper) {
                          itemQtyWrapper.classList.add('is-loading');
                      }
              
                      if (itemQtyInput) {
                          itemKeys.push(itemKey);
                          itemQuantities.push(itemQuantity);
                          itemQtyInputs.push(itemQtyInput);
                          totalQuantity += itemQuantity;
                      }
                  });
              
                  function removeNextItems(index, count) {
                      if (index < itemKeys.length && count < 2) {
                          const itemKey = itemKeys[index];
                          const quantity = 1;
                          
                          changeItemInCart(itemKey, function() {
                              console.log('Item removed:', index + 1);
                              removeNextItems(index + 1, count + 1);
                          }, quantity); // Pass negative quantity to remove items
                      } else if (count === 2 || index >= itemKeys.length) {
                          window.location.reload();
                      }
                  }
              
                  if (itemKeys.length > 0) {
                      removeNextItems(0, 0);
                  }
              }else {
                  ThisOriginalRemove.click();
              }
          } else {
              ThisOriginalRemove.click();
          }
      }
  });
  }else{
  document.addEventListener("click", function(event) {
      if (event.target.matches(".js-qty__adjust--minus-custom")) {
          var removeItemKey = event.target.getAttribute('data-remove-item');
          const cartDrawer = document.getElementById('CartDrawer');
          const ThisOriginalRemove = event.target.closest('.cart__item').querySelector('button.js-qty__adjust--minus');
  
          if (removeItemKey) {
              const matchingItems = cartDrawer.querySelectorAll(`[data-remove-item="${removeItemKey}"]`);
              let totalQty = 0;
              let FreeItem = 0;
              let OtherItem = 0;
              let limitedProducts = 0
              matchingItems.forEach(function(item) {
                  const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
                 if(item.hasAttribute('free-cart-item')){
                   FreeItem++
                 }else if(item.hasAttribute('limit-bundle')){
                   for (let i = 0; i < item.closest('.cart__item').querySelector('input.js-qty__num').value; i++) {
                   limitedProducts++
                   }
                 }else{
                   for (let i = 0; i < itemQtyInput.value; i++) {
                   OtherItem++
                   }
                 }
                  totalQty += itemQtyInput ? parseInt(itemQtyInput.value) : 0;
              });
  
              console.log('matchingItemsQty', totalQty);
              console.log('FreeItem', FreeItem);
              console.log('OtherItem', OtherItem);
  
              if (!event.target.hasAttribute('free-cart-item') && FreeItem > 0 && OtherItem === 1 && !event.target.hasAttribute('limit-bundle')) {
                  const itemKeys = [];
                  matchingItems.forEach(function(item) {
                      const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
                      const itemQtyWrapper = item.closest('.cart__item').querySelector('.js-qty__wrapper');
                      const itemKey = item.getAttribute('item-id');
                       if(itemQtyWrapper){
                         itemQtyWrapper.classList.add('is-loading')
                       }
                      if (itemQtyInput) {
                          itemKeys.push(itemKey);
                      }
                  });
  
                  if (itemKeys.length > 0) {
                    function removeNextItem(index) {
                        if (index < itemKeys.length) {
                            changeItemInCart(itemKeys[index], function() {
                                console.log('Item removed:', index + 1);
                                removeNextItem(index + 1); // Proceed to the next item after the current one is removed
                            });
                        } else {
                            // All items have been processed, reinitialize the cart drawer
                            CartDrawerInit();
                        }
                    }
                
                    // Start removing items from the first one
                    removeNextItem(0);
                }
              } else if (event.target.hasAttribute('limit-bundle') && limitedProducts > 0 && FreeItem > 0 ) {
                          const itemKeys = [];
                          const itemQuantities = [];
                          const itemQtyInputs = [];
                          let totalQuantity = 0;
                      
                          matchingItems.forEach(function(item) {
                              const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
                              const itemQtyWrapper = item.closest('.cart__item').querySelector('.js-qty__wrapper');
                              const itemKey = item.getAttribute('item-id');
                              const itemQuantity = parseInt(itemQtyInput.value);
                      
                              if (itemQtyWrapper) {
                                  itemQtyWrapper.classList.add('is-loading');
                              }
                      
                              if (itemQtyInput) {
                                  itemKeys.push(itemKey);
                                  itemQuantities.push(itemQuantity);
                                  itemQtyInputs.push(itemQtyInput);
                                  totalQuantity += itemQuantity;
                              }
                          });
                      
                          function removeNextItems(index, count) {
                              if (index < itemKeys.length && count < 2) {
                                  const itemKey = itemKeys[index];
                                  const quantity = itemQuantities[index];
                                  
                                  changeItemInCart(itemKey, function() {
                                      console.log('Item removed:', index + 1);
                                      removeNextItems(index + 1, count + 1);
                                  }, quantity); // Pass negative quantity to remove items
                              } else if (count === 2 || index >= itemKeys.length) {
                                 CartDrawerInit();
                              }
                          }
                      
                          if (itemKeys.length > 0) {
                              removeNextItems(0, 0);
                          }
                      }
  
              else {
                  ThisOriginalRemove.click();
              }
          } else {
              ThisOriginalRemove.click();
          }
      }
  });
  }
  
  
  
  
  
  
  
  
  
  
  
  
  
  // ==============================================================================Backup orignal removal function ========================
  
  
  // var Location = window.location.href
  // if(Location.includes('/cart')){
    
  // document.addEventListener("click", function(event) {
  //     if (event.target.matches(".js-qty__adjust--minus-custom")) {
  //         var removeItemKey = event.target.getAttribute('data-remove-item');
  //         const cartDrawer = document.getElementById('CartPageForm');
  //         const ThisOriginalRemove = event.target.closest('.cart__item').querySelector('button.js-qty__adjust--minus');
  //         if (removeItemKey) {
  //             const matchingItems = cartDrawer.querySelectorAll(`[data-remove-item="${removeItemKey}"]`);
  //             let totalQty = 0;
  //           let FreeItem = 0;
  //             matchingItems.forEach(function(item) {
  //                 if(item.hasAttribute('free-cart-item')){
  //                  FreeItem = 1 + FreeItem
  //                }
  //                 const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
  //                 totalQty += itemQtyInput ? parseInt(itemQtyInput.value) : 0;
  //             });
  
  //             console.log('matchingItemsQty', totalQty);
  
  //             if (totalQty === 2  && FreeItem > 0 ) {
  //                 const itemKeys = [];
  //                 matchingItems.forEach(function(item) {
  //                     const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
  //                     const itemQtyWrapper = item.closest('.cart__item').querySelector('.js-qty__wrapper');
  //                     const itemKey = item.getAttribute('item-id');
  //                      if(itemQtyWrapper){
  //                        itemQtyWrapper.classList.add('is-loading')
  //                      }
  //                     if (itemQtyInput) {
  //                         itemKeys.push(itemKey);
  //                     }
  //                 });
  
  //                 if (itemKeys.length > 0) {
  //                     // Remove the first item
  //                     changeItemInCart(itemKeys[0], function() {
  //                         // On success, remove the second item if it exists
  //                         if (itemKeys.length > 1) {
  //                             changeItemInCart(itemKeys[1], function() {
  //                                 location.reload();
  //                             });
  //                         } else {
  //                           location.reload();
  //                         }
  //                     });
  //                 }
  //             } else {
  //                 ThisOriginalRemove.click();
  //             }
  //         } else {
  //             ThisOriginalRemove.click();
  //         }
  //     }
  //     if (event.target.matches(".cart__remove-custom a")) {
  //         var removeItemKey = event.target.getAttribute('data-remove-item-remove');
  //         const cartDrawer = document.getElementById('CartPageForm');
  //         const ThisOriginalRemove = event.target.closest('.cart__item').querySelector('button.js-qty__adjust--minus');
  
  //         if (removeItemKey) {
  //             const matchingItems = cartDrawer.querySelectorAll(`[data-remove-item-remove="${removeItemKey}"]`);
  //             let totalQty = 0;
  //            let FreeItem = 0;
  //             matchingItems.forEach(function(item) {
  //                if(item.hasAttribute('free-cart-item')){
  //                  FreeItem = 1 + FreeItem
  //                }
  //                 const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
  //                 totalQty += itemQtyInput ? parseInt(itemQtyInput.value) : 0;
  //             });
  
  //             console.log('matchingItemsQty', totalQty);
  
  //             if (totalQty === 2  && FreeItem > 0 ) {
  //                 const itemKeys = [];
  //                 matchingItems.forEach(function(item) {
  //                     const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
  //                     const itemQtyWrapper = item.closest('.cart__item').querySelector('.js-qty__wrapper');
  //                     const itemKey = item.getAttribute('item-id-remove');
  //                      if(itemQtyWrapper){
  //                        itemQtyWrapper.classList.add('is-loading')
  //                      }
  //                     if (itemQtyInput) {
  //                         itemKeys.push(itemKey);
  //                     }
  //                 });
  //                console.log('itemKeys', itemKeys)
  //                 if (itemKeys.length > 0) {
  //                     let itemsProcessed = 0;
                  
  //                     itemKeys.forEach(function(itemKey, index) {
  //                         changeItemInCart(itemKey, function() {
  //                             itemsProcessed++;
  //                             if (itemsProcessed === itemKeys.length) {
  //                                 // All items have been processed, reinitialize the cart drawer
  //                                 CartDrawerInit();
  //                             }
  //                       console.log('itemsProcessed', itemsProcessed)
  //                         });
  //                     });
  //                 }
  
  //             } else {
  //                 ThisOriginalRemove.click();
  //             }
  //         } else {
  //             ThisOriginalRemove.click();
  //         }
  //     }
  // });
  // }else{
  // document.addEventListener("click", function(event) {
  //     if (event.target.matches(".js-qty__adjust--minus-custom")) {
  //         var removeItemKey = event.target.getAttribute('data-remove-item');
  //         const cartDrawer = document.getElementById('CartDrawer');
  //         const ThisOriginalRemove = event.target.closest('.cart__item').querySelector('button.js-qty__adjust--minus');
  
  //         if (removeItemKey) {
  //             const matchingItems = cartDrawer.querySelectorAll(`[data-remove-item="${removeItemKey}"]`);
  //             let totalQty = 0;
  //             let FreeItem = 0;
  //             let OtherItem = 0;
  //             matchingItems.forEach(function(item) {
  //                 const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
  //                if(item.hasAttribute('free-cart-item')){
  //                  FreeItem++
  //                }else{
  //                  for (let i = 0; i < itemQtyInput.value; i++) {
  //                  OtherItem++
  //                  }
  //                }
  //                 totalQty += itemQtyInput ? parseInt(itemQtyInput.value) : 0;
  //             });
  
  //             console.log('matchingItemsQty', totalQty);
  //             console.log('FreeItem', FreeItem);
  //             console.log('OtherItem', OtherItem);
  
  //             if (!event.target.hasAttribute('free-cart-item') && FreeItem > 0 && OtherItem === 1) {
  //                 const itemKeys = [];
  //                 matchingItems.forEach(function(item) {
  //                     const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
  //                     const itemQtyWrapper = item.closest('.cart__item').querySelector('.js-qty__wrapper');
  //                     const itemKey = item.getAttribute('item-id');
  //                      if(itemQtyWrapper){
  //                        itemQtyWrapper.classList.add('is-loading')
  //                      }
  //                     if (itemQtyInput) {
  //                         itemKeys.push(itemKey);
  //                     }
  //                 });
  
  //                 if (itemKeys.length > 0) {
  //                   function removeNextItem(index) {
  //                       if (index < itemKeys.length) {
  //                           changeItemInCart(itemKeys[index], function() {
  //                               console.log('Item removed:', index + 1);
  //                               removeNextItem(index + 1); // Proceed to the next item after the current one is removed
  //                           });
  //                       } else {
  //                           // All items have been processed, reinitialize the cart drawer
  //                           CartDrawerInit();
  //                       }
  //                   }
                
  //                   // Start removing items from the first one
  //                   removeNextItem(0);
  //               }
  //             } else {
  //                 ThisOriginalRemove.click();
  //             }
  //         } else {
  //             ThisOriginalRemove.click();
  //         }
  //     }
  // });
  
  
  
  // }
  // function changeItemInCartRemove(itemKey, quantity, callback) {
  //     fetch('/cart/change.js', {
  //         method: 'POST',
  //         headers: {
  //             'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify({
  //             id: itemKey,
  //             quantity: quantity
  //         })
  //     })
  //     .then(response => response.json())
  //     .then(data => {
  //         console.log('Cart updated:', data);
  //         if (callback) callback();
  //     })
  //     .catch(error => {
  //         console.error('Error updating cart:', error);
  //     });
  // }
  
  // document.addEventListener("click", function(event) {
  //     console.log('Event type:', event.type); // Debugging log
  //     if (event.target.matches(".cart__remove-custom a")) {
  //         console.log('Click detected on .cart__remove-custom a'); // Debugging log
  //         event.preventDefault();
          
  //         const removeItemKey = event.target.getAttribute('data-remove-item-remove');
  //         const itemKey = event.target.getAttribute('item-id-remove');
  //         const cartDrawer = document.getElementById('CartDrawer');
  //         const thisOriginalRemove = event.target.closest('.cart__item').querySelector('.cart__remove a');
          
  //         console.log('Remove item key:', removeItemKey);
  //         console.log('Item key:', itemKey);
  
  //         if (removeItemKey) {
  //             const matchingItems = cartDrawer.querySelectorAll(`[data-remove-item-remove="${removeItemKey}"]`);
  //             let totalQty = 0;
  
  //             matchingItems.forEach(item => {
  //                 const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
  //                 totalQty += itemQtyInput ? parseInt(itemQtyInput.value) : 0;
  //             });
  
  //             console.log('Total quantity of matching items:', totalQty);
  
  //             if (totalQty === 2) {
  //                 const itemKeys = [];
  //                 matchingItems.forEach(item => {
  //                     const itemQtyInput = item.closest('.cart__item').querySelector('input.js-qty__num');
  //                     const itemQtyWrapper = item.closest('.cart__item').querySelector('.js-qty__wrapper');
  //                     const itemKey = item.getAttribute('item-id-remove');
                      
  //                     if (itemQtyWrapper) {
  //                         itemQtyWrapper.classList.add('is-loading');
  //                     }
                      
  //                     if (itemQtyInput) {
  //                         itemKeys.push(itemKey);
  //                     }
  //                 });
  
  //                 console.log('Item keys to be removed:', itemKeys);
  
  //                 if (itemKeys.length > 0) {
  //                     changeItemInCartRemove(itemKeys[0], 0, () => {
  //                         if (itemKeys.length > 1) {
  //                             changeItemInCart(itemKeys[1], 0, () => {
  //                                 console.log('Page will reload after removing second item');
  //                                 location.reload();
  //                             });
  //                         } else {
  //                             console.log('Page will reload after removing first item');
  //                             location.reload();
  //                         }
  //                     });
  //                 }
  //             } else {
  //                  thisOriginalRemove.click();
  //             }
  //         } else {
  //             thisOriginalRemove.click();
  //         }
  //     }
  // });
  
  
  
  
  
  
  
  
  
  jQuery(document).ready(function(){
      jQuery('.faq-single .faq-btn').on('click', function(e){
        e.preventDefault();
       if(jQuery(this).hasClass('active')){
        jQuery(this).removeClass('active');
        jQuery(this).siblings('.faq-content').removeClass('open').slideUp(350);
      }
      else{
        jQuery('.faq-content').removeClass('open').slideUp(350);
        jQuery('.faq-btn').removeClass('active');
        jQuery(this).addClass('active');
        jQuery(this).siblings('.faq-content').addClass('open').slideToggle(350);
      }
    })
  
  $(document).on('click','.main-card-section .accent-btn',function(){ 
    var ID = $(this).attr("data-id"); 
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID
      },
       dataType: 'json', 
       success: function(data){ 
         window.location.href="/checkout"
       } 
    })
  }) 
  
    
  })
    
   $(document).ready(function() {
     $(document).on("click",".play-gif",function() {
                  $(this).parents('.vid_img_box_item').find('video').trigger('play');
                  $(this).hide();
                  $(this).parents('.vid_img_box_item').addClass('play-video');
              });
      $(document).on("click",".play-video video",function() {
                  $(this).trigger('pause');
                   $(this).parents('.vid_img_box_item').removeClass('play-video');
                   $(this).parents('.vid_img_box_item').find('.play-gif').show();
              });
          });
  
  function scrollToTop(){
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
  
  
         var cartDrawer = document.querySelector('#CartDrawerForm'); // Adjust selector if necessary
          if (cartDrawer) {
            var onOff = cartDrawer.querySelector('#on-off');
             if (onOff) {

            var Productionid = cartDrawer.querySelector('#on-off').getAttribute('value')
              var Leakobserver = new MutationObserver(function(mutations) {
                  mutations.forEach(function(mutation) {
                      $.getJSON('/cart.js', function(cart) {
                          var cartCount = cart.item_count;
                          if (cartCount === 1) {
                              cart.items.forEach(function(item) {
                                  if (item.id === parseInt(Productionid)) {
                                // console.log('item_id ', item.key )
                                      removeProductFromCart(item.key);
                                  }
                              });
                          }
                      });
                  });
              });
  
              Leakobserver.observe(cartDrawer, { childList: true, subtree: true });
          }
        }
   function removeProductFromCart(itemKey) {
      $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: JSON.stringify({
              quantity: 0,
              id: itemKey
          }),
          dataType: 'json',
          contentType: 'application/json',
          success: function(cart) {
              console.log('Product removed successfully:', cart);
            CartDrawerInit();
          },
          error: function(error) {
              console.error('Error removing product:', error);
          }
      });
  }



  //custom add to cart for lipstick product

//   class LipsAddToCart extends HTMLElement {
//   constructor() {
//     super();
//       console.log(product.selected_or_first_available_variant.price); // cents
//   }

//   connectedCallback() {
//     this.innerHTML = `
//     <div class="radio-buttons">
//       <input type="radio"     id="option1"    name="one_two_pack"    value="1"    data-quantity="1"    checked>
//     <label for="option1">1 Lipstic <span class="price">{{product.price }}</span></label>

//     <input type="radio" id="option2" name="one_two_pack" value="2" data-quantity='2'>
//     <label for="option2">2 Pack <span class="price">{{product.price | times:2}}</span></label>
//     </div>

//     <button class="lips-add-to-cart">Add To Cart</button>
//     `;
//   }
// }

// customElements.define('lips-add-to-cart', LipsAddToCart);


//lips signature product page slider
  document.addEventListener('DOMContentLoaded', function () {
      $('.loved-by-section__slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
         {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ],
    prevArrow: `
      <button type="button" class="slick-prev">
        <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22.2734" cy="22.2734" r="21.7734" transform="matrix(-1 0 0 1 44.5469 0)" fill="white" stroke="black"/>
        <path d="M25.8408 16.8483L24.7798 15.7883L19.0008 21.5653C18.9077 21.6579 18.8337 21.768 18.7833 21.8892C18.7328 22.0105 18.7069 22.1405 18.7069 22.2718C18.7069 22.4032 18.7328 22.5332 18.7833 22.6544C18.8337 22.7757 18.9077 22.8858 19.0008 22.9783L24.7798 28.7583L25.8398 27.6983L20.4158 22.2733L25.8408 16.8483Z" fill="black"/>
        </svg>
      </button>
    `,

    nextArrow: `
      <button type="button" class="slick-next">
        <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22.2734" cy="22.2734" r="21.7734" fill="white" stroke="black"/>
        <path d="M18.7061 16.8483L19.7671 15.7883L25.5461 21.5653C25.6392 21.6579 25.7131 21.768 25.7636 21.8892C25.814 22.0105 25.84 22.1405 25.84 22.2718C25.84 22.4032 25.814 22.5332 25.7636 22.6544C25.7131 22.7757 25.6392 22.8858 25.5461 22.9783L19.7671 28.7583L18.7071 27.6983L24.1311 22.2733L18.7061 16.8483Z" fill="black"/>
        </svg>
      </button>
    `
      });
   
});


// review sectoi on signature lipstic page.
// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".loved-by-section__read-more").forEach(function(btn) {
//     btn.addEventListener("click", function(e) {
//       e.preventDefault();

//        const review = this.closest(".loved-by-section__card")
//                          .querySelector(".loved-by-section__review");

//       review.classList.toggle("expanded");

//       if (review.classList.contains("expanded")) {
//         this.textContent = "Read Less";
//       } else {
//         this.textContent = "Read More";
//       }
//     });
//   });
// });



  //counter of beauty secret page 
  (function () {
  const countdownEl = document.getElementById("countdown");

  if (!countdownEl) return;

  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;

  const countdownHours = parseInt(countdownEl.dataset.time, 10) || 4;
  const storageKey = "countdown_end_time";

  let endTime = localStorage.getItem(storageKey);

  if (!endTime || Date.now() > endTime) {
    endTime = Date.now() + countdownHours * hour;
    localStorage.setItem(storageKey, endTime);
  }

  setInterval(() => {
    let distance = endTime - Date.now();

    if (distance <= 0) {
      // Restart countdown
      endTime = Date.now() + countdownHours * hour;
      localStorage.setItem(storageKey, endTime);
      distance = endTime - Date.now();
    }

    const hours = Math.floor(distance / hour);
    const minutes = Math.floor((distance % hour) / minute);
    const seconds = Math.floor((distance % minute) / second);

    document.getElementById("hours").textContent = String(hours).padStart(2, "0");
    document.getElementById("minutes").textContent = String(minutes).padStart(2, "0");
    document.getElementById("seconds").textContent = String(seconds).padStart(2, "0");
  }, 1000);
})();

//counter for product page
  (function () {
  const countdownEl = document.querySelector(".countdown-timer-container #countdown");

  if (!countdownEl) return;

  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
    const RESET_THRESHOLD = 3 * 60 * 60 * 1000; // 3 hours
  const countdownHours = parseInt(countdownEl.dataset.time, 10) || 4;
  const storageKey = "product_countdown_end_time";

  let endTime = localStorage.getItem(storageKey);

  if (!endTime || Date.now() > endTime) {
    endTime = Date.now() + countdownHours * hour;
    localStorage.setItem(storageKey, endTime);
  }

  setInterval(() => {
    let distance = endTime - Date.now();

    if (distance <= RESET_THRESHOLD) {
      // Restart countdown
      endTime = Date.now() + countdownHours * hour;
      localStorage.setItem(storageKey, endTime);
      distance = endTime - Date.now();
    }

    const hours = Math.floor(distance / hour);
    const minutes = Math.floor((distance % hour) / minute);
    const seconds = Math.floor((distance % minute) / second);

    document.getElementById("hours").textContent = String(hours).padStart(2, "0");
    document.getElementById("minutes").textContent = String(minutes).padStart(2, "0");
    document.getElementById("seconds").textContent = String(seconds).padStart(2, "0");
  }, 1000);
})();



//Beaury secret page stats number showing from zero when sec in the viewport
document.addEventListener('DOMContentLoaded', () => {

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (!entry.isIntersecting) return;

      const counter = entry.target;
      const target = parseInt(counter.dataset.target);

      const progressCircle = counter
        .parentElement
        .querySelector('.percentage-circle-progress');

      let count = 0;

      const circumference = 282.743;

      const interval = setInterval(() => {

        count++;

        counter.textContent = count;

        // SVG progress update
        const offset =
          circumference - (count / 100) * circumference;

        progressCircle.style.strokeDashoffset = offset;

        if (count >= target) {
          clearInterval(interval);
        }

      }, 50);

      observer.unobserve(counter);

    });

  }, {
    threshold: 0.5
  });

  document.querySelectorAll('.beauty-secret-stat__counter').forEach(counter => {
    observer.observe(counter);
  });

});





//js to show the price below title on the "venom-p-50" product page



     function getDefaultProductPrice(compareAtPrice){
      let defaultPrice = document.querySelector('.lux-bundle-summary button#lux-add-to-cart .final-price-50ml-sub');
      const baseClass = document.querySelector('.temp--venom-perfume-50ml-subs')
        ? '.temp--venom-perfume-50ml-subs'
        : document.querySelector('.temp--venom-perfume-50ml-subs-n')
        ? '.temp--venom-perfume-50ml-subs-n'
        : document.querySelector('.temp--venom-perfume-50ml-09')
        ? '.temp--venom-perfume-50ml-09'
        : null;

      let selectOnePerfume = document.querySelector('.lux-pack-progress-item.active[data-pack="1"]');
      let selectTwoPerfume =  selectOnePerfume && document.querySelector('.lux-pack-progress-item.active[data-pack="2"]');
      let selectThreePerfume =  selectOnePerfume && selectTwoPerfume &&document.querySelector('.lux-pack-progress-item.active[data-pack="3"]');
       if(defaultPrice){
          document.querySelector(`${baseClass} div#sy-price-display .sy-price-container .py-price-row #p-50-discounted-price`).textContent = defaultPrice.textContent;
          if(selectThreePerfume){
           
              const text =  sessionStorage.getItem('compareAtPrice');
              const currency = text.match(/^[^\d]+/)?.[0] || '';
              const price = parseFloat(text.replace(/[^0-9.]/g, ''));

              document.querySelector(
                `${baseClass} div#sy-price-display .sy-price-container .py-price-row #p-50-original-price`
              ).innerText = `${currency}${(price * 3).toFixed(2)}`;
           
          }

          else if(selectTwoPerfume){
           
              const text =  sessionStorage.getItem('compareAtPrice');
              const currency = text.match(/^[^\d]+/)?.[0] || '';
              const price = parseFloat(text.replace(/[^0-9.]/g, ''));

              document.querySelector(
                `${baseClass} div#sy-price-display .sy-price-container .py-price-row #p-50-original-price`
              ).innerText = `${currency}${(price * 2).toFixed(2)}`;
          
          }
        
         
          else if(selectOnePerfume){
          
             
              document.querySelector(
                `${baseClass} div#sy-price-display .sy-price-container .py-price-row #p-50-original-price`
              ).innerText =  sessionStorage.getItem('compareAtPrice');
          }

          return defaultPrice;
        }
    }

      document?.addEventListener('DOMContentLoaded', function() {
         const baseClass = document.querySelector('.temp--venom-perfume-50ml-subs')
            ? '.temp--venom-perfume-50ml-subs'
            : document.querySelector('.temp--venom-perfume-50ml-subs-n')
            ? '.temp--venom-perfume-50ml-subs-n'
            : '.temp--venom-perfume-50ml-09';
         const compareAtPrice = document.querySelector(`${baseClass} div#sy-price-display .sy-price-container .py-price-row #p-50-original-price`);
           sessionStorage.setItem('compareAtPrice', compareAtPrice.textContent);
        getDefaultProductPrice();
        document.querySelectorAll('.lux-scent-quantity .lux-quantity-btn, button.lux-quantity-btn.lux-plus, .lux-scent-options .lux-scent-option .add-button, .subscription-checkbox-wrapper').forEach(el =>
            el.addEventListener('click', () =>
            setTimeout(() => getDefaultProductPrice(), 500)
          )
        );
      });
   
 

//js to show the price of only buy 1 get 1 on the "venom-p-10-3" product
document?.addEventListener('DOMContentLoaded', function() {
  function changeThePriceAtTop(){

        const priceElement = document.querySelector(
          ".sy-roll-ons-pack-options .sy-roll-ons-pack-option[data-pack='1'] .sy-roll-ons-pack-option-flex #per-bottle-price-pack-1"
        );
        const mainPriceElement = document.querySelector('#sy-price-display .sy-price-row #sy-discounted-price-get-one')

        if (priceElement) {
          const originalText = priceElement.textContent.trim();

          // Currency/symbol ko preserve karte hue numeric value extract karega
          const match = originalText.match(/^(\D*)([\d.,]+)(\D*)$/);

          if (match) {
            const currencyBefore = match[1];
            const number = parseFloat(match[2].replace(/,/g, ""));
            const currencyAfter = match[3];

            if (!isNaN(number)) {
             const newPrice = (number * 2).toFixed(2);

              mainPriceElement.textContent = `${currencyBefore}${newPrice}${currencyAfter}`;
            }
          }
        }
  }
    setTimeout(() => {
          changeThePriceAtTop();
    }, 1000);

      document.querySelectorAll(
        '.subscription-options-new-10ml label.subscription-checkbox-wrapper-10ml'
      ).forEach(function (element) {
        element.onclick = function () {
          setTimeout(() => {
            changeThePriceAtTop();
          }, 500);
        };
      });
});


//clicking on the kaching bundle based on qty selected in the widget
document.querySelector(".sy-roll-ons-pack-option[data-pack='1']")?.addEventListener("click", function () {
   document.querySelector(".kaching-bundles__bar[data-deal-bar-id='5Bqp'] .kaching-bundles__bar-main").click();
});

document.querySelector(".sy-roll-ons-pack-option[data-pack='2']")?.addEventListener("click", function () {
   document.querySelector(".kaching-bundles__bar[data-deal-bar-id='dYzH'] .kaching-bundles__bar-main").click();
});

document.querySelector(".sy-roll-ons-pack-option[data-pack='3']")?.addEventListener("click", function () {
   document.querySelector(".kaching-bundles__bar[data-deal-bar-id='2q0W'] .kaching-bundles__bar-main").click();
});





